import { PermissionEnum } from "types/enums";
import { RequiredStaticData } from "utils/createPaldockFileRoute.ts";

export function isRouteAccessible(
    staticData: Pick<RequiredStaticData, "isPublic" | "permissions" | "redirectPermissions">,
    hasAtLeastOnePermission: (permissions: PermissionEnum[]) => boolean
): boolean {
    if (staticData.isPublic) return true;

    const permissions = staticData.permissions;
    if (!permissions?.length) return false;

    if (staticData.redirectPermissions) {
        return hasAtLeastOnePermission([...permissions, ...staticData.redirectPermissions]);
    }

    return hasAtLeastOnePermission(permissions);
}
